import './index.scss'
import fullpage from 'fullpage.js'
import 'fullpage.js/dist/fullpage.min.css'
import Swiper from 'swiper/swiper-bundle.min'
import '../../assets/scripts/jquery.mousewheel'
import '../../assets/scripts/countNumber'
import '@fancyapps/fancybox/dist/jquery.fancybox.min'

!(function(){
  $('header').addClass('white')
})()

$(document).ready(function(){
  getDetailW()
  if($(window).width() > 1024){
    initFullpage()
  }
})

$('.mob-header ul li').eq(1).find('.sub-nav a').on('click',function(){
  $('header .menu-icon').removeClass('active')
  $('header .hamburger').removeClass('active')
  $('header .mob-header').removeClass('show')
  $('header .mask').fadeOut(200)
})

//数字滚动效果
function numScroll () {
  let num1 = $("#scrollNum1").html()
  let num2 = $("#scrollNum2").html()
  let num3 = $("#scrollNum3").html()
  let num4 = $("#scrollNum4").html()
  let num5 = $("#scrollNum5").html()
  let num6 = $("#scrollNum6").html()
  $("#scrollNum1").rollNum({
      deVal: num1
  });
  $("#scrollNum2").rollNum({
      deVal: num2
  });
  $("#scrollNum3").rollNum({
      deVal: num3
  });
  $("#scrollNum4").rollNum({
      deVal: num4
  });
  $("#scrollNum5").rollNum({
    deVal: num5
  });
  $("#scrollNum6").rollNum({
    deVal: num6
  });
}

//全屏滚动
var afullpage;
function initFullpage() {
  afullpage = new fullpage('#fullpage', {
    scrollingSpeed: 600,
    css3: true,
    resize:true,
    autoScrolling: true,
    scrollBar: false,
    normalScrollElements: '.section6 .swiper',
    anchors: ['page1', 'page2', 'page3', 'page4','page5','page6','page7','page8'],
		menu: '#menu',
    afterLoad: function (origin, destination, direction, trigger) {
      let i = destination.index;
      if(i == 0){
        // numScroll ()
        $('#menu').css({'opacity':'0'})
        $('header').addClass('white')
      }else{
        $('#menu').css({'opacity':'1'})
        $('header').removeClass('white')
      }
      if(i == 7){
        afullpage.setAllowScrolling(false);
      }
    },
    onLeave: function (origin, destination, direction,trigger) {
      if(origin.index == 0 && destination.index == 1){
        // $('#menu').fadeIn()
        numScroll ()
      }
      if(origin.index == 1 && destination.index == 0){
        $('#menu').css({'opacity':'0'})
        $('header').addClass('white')
      }
    }
  });
}

//页面滚动监听
$(document).scroll(function () {
  var scroH = $(document).scrollTop(); //滚动高度
  var viewH = $(window).height(); //可见高度
  var contentH = $(document).height(); //内容高度

  if($(window).width() <= 1024){
    if (scroH > $('.section2 .right').offset().top - viewH) {
      numScroll ()
    }
  }
});
$('#menu li').on('click',function(){
  afullpage.setAllowScrolling(true);
  $('.fixed-footer').removeClass('show')
})
//底部footer效果
function footerF(event, delta){
  let footerH = $('.fixed-footer').outerHeight()
  if(delta > 0){//返回，上滚
    if(!$('.fixed-footer').hasClass('show')){
      afullpage.setAllowScrolling(true);
    }else{
      $('.fixed-footer').removeClass('show')
      $('.footer-tran').css('transform','none')
      $('.trans-menu').css('transform','translateY(-50%)')
    }
  }else if(delta < 0){//下滚，显示footer
    if(!$('.fixed-footer').hasClass('show')){
      $('.fixed-footer').addClass('show')
      $('.footer-tran').css('transform','translateY('+ -footerH +'px)')
      $('.trans-menu').css('transform',' translateY(calc(-50% - '+ footerH +'px))')
    }
  }
  event.preventDefault();
}

if($(window).width() > 1024){
  $('#fullpage .section8').bind('mousewheel',function(event, delta) {
    footerF(event, delta)
  });
  $('.fixed-footer').mousewheel(function(event, delta) {
    if(delta > 0){//返回，上滚
      $('.fixed-footer').removeClass('show')
      $('.footer-tran').css('transform','none')
      $('.trans-menu').css('transform','translateY(-50%)')
    }
    event.preventDefault();
  });
}

$('footer .footer-nav ul li .sub-nav a').on('click',function(){
  $('.fixed-footer').removeClass('show')
  $('.footer-tran').css('transform','none')
  $('.trans-menu').fadeIn(200)
  afullpage.setAllowScrolling(true);
})

// banner轮播
var bannerswiper = new Swiper(".about-banner .mySwiper", {
  effect: 'fade',
  speed: 1000,
  autoplay: {
    delay: 5000,
    stopOnLastSlide: false,
    disableOnInteraction: false,
  },
});

// 历史轮播
let timeLineSwiper = new Swiper('.section6 .timeline-swiper', {
  mousewheel: true,
  direction: 'vertical',
  slidesPerView: 'auto',
  watchSlidesProgress: true,
  watchSlidesVisibility: true,
})
let swiper = new Swiper('.section6 .history-swiper', {
  mousewheel: true,
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
  allowTouchMove: true,
  autoHeight: true,
  navigation: {
    nextEl: '.section6 .history-swiper .swiper-button-next',
    prevEl: '.section6 .history-swiper .swiper-button-prev'
  },
  pagination: {
    el: '.section6 .history-swiper .swiper-pagination',
    clickable :true,
  },
  thumbs: {
    swiper: timeLineSwiper,
  },
  on: {
    transitionStart () {
      timeLineSwiper.slideTo(this.realIndex)
    },
    transitionEnd () {
      timeLineSwiper.update()
    }
  }
})

//职位效果
//电脑端 获取列表宽度，赋值给详情板块，保证列表与详情同等宽度
function getDetailW(){
  let DetailW = $('.section8 .career').outerWidth()
  $('.section8 .detail-list ul').css('width',DetailW+'px')
}
$(window).resize(function(){
  getDetailW()
})

//点击列表
$('.section8 .career ul').on('click','li',function(){
  if($(window).width()>1024){
    // 电脑端 列表与详情同时左移，解绑职位模块的鼠标监听，为详情部分添加鼠标监听事件，模拟滚动
    if($(this).index() != 0){
      $('.section8').addClass('show-detail')
      $('.section8 .detail-list ul li').eq($(this).index()-1).show().siblings().hide()

      $('#fullpage .section8').unbind('mousewheel')
  
      let El = $('.section8 .detail-list ul li').eq($(this).index()-1).find('.item-desc')
      $(El).bind('mousewheel',function(event, delta) {
        detailscroll(El,event, delta)
      });
    }
  }else{
    // 移动端
    if($(this).hasClass('active')){
      $(this).removeClass('active').find('.item-desc').slideUp()
    }else{
      $('.section8 .career li').removeClass('active').find('.item-desc').slideUp()
      $(this).addClass('active').find('.item-desc').slideDown()
    }
  }
})
//点击详情返回按钮，列表与详情同时右移，解绑详情模块的鼠标监听，为整个职位板块添加鼠标监听，判断是否显示footer
$('.section8 .detail-list .item-title .iconfont').on('click',function(){
  let El  = $(this).parents('li').find('.item-desc')

  $('.section8').removeClass('show-detail')
  $(El).unbind('mousewheel')
  
  $('#fullpage .section8').bind('mousewheel',function(event, delta) {
    footerF(event, delta)
  });

  setTimeout(() => {
    h = 0
    $(El).animate({scrollTop: 0});
  }, 300);
})

//电脑端 职位详情模拟滚动
var h = 0;
function detailscroll(El,event, delta){
  console.log(delta,event.deltaFactor)
  if(delta == 1 ){
    h <= 0 ? h = 0 : h += event.deltaFactor*(-delta)
  }else if(delta == -1){
    let fH = $(El).height()
    let sonH = $(El).find('.realH').height()
    if(h>= sonH - fH){
      h = sonH - fH
    }else{
      h += event.deltaFactor*(-delta)
    }
  }
  $(El).animate({scrollTop: h},{duration: 50,easing: "linear"});
}